import { createSlice } from "@reduxjs/toolkit";
import api from "../../Services/ApiServices";
import { IStage8Info } from "../../Types/AccountOpeningRequest";
import { dispatch, RootState } from "../store";
import utils from "../../Services/Utils";
import { IENACHMandateForm } from "../../Pages/Step8/ESignComplete";

interface IStep8State {
  isLoading?: boolean;
  error?: any;
  stage8Info?: IStage8Info;
  isCompleted?: boolean;
}
const initialState: IStep8State = {};

const slice = createSlice({
  name: "stage8",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = undefined;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    stage8Success(state, action) {
      state.stage8Info = action.payload;
      state.isLoading = false;
    },
    setCompleted(state, action) {
      state.isCompleted = action.payload;
    },
    resetFields() {
      return { ...initialState };
    },
  },
});

// Reducer
export default slice.reducer;

export const { resetFields, setCompleted } = slice.actions;

export const fetchStage8Info = () => {
  return async (disp: any, getState: () => RootState) => {
    try {
      await dispatch(slice.actions.startLoading());

      const { objAuthInfoResponse } = getState().common;
      let response = await api.ValidateUserIsEligibleToDoESign({
        AOSAI: JSON.stringify(objAuthInfoResponse),
      });
      await dispatch(slice.actions.stage8Success(response));
    } catch (ex) {
      console.log(ex, "ex");
      await dispatch(slice.actions.hasError(ex));
    }
  };
};

export const doEACHMandate = (values: IENACHMandateForm) => {
  return async (disp: any, getState: () => RootState) => {
    try {
      const { objAuthInfoResponse, objAOR } = getState().common;
      if (!objAOR) throw new Error("Account opening request not found");
      
      const [Fday, Fmonth, Fyear] = values.mandateFromDate.split('/');
      const formattedFromDate = new Date(`${Fyear}-${Fmonth}-${Fday}`);

      const [Tday, Tmonth, Tyear] = values.mandateToDate.split('/');
      const formattedToDate = new Date(`${Tyear}-${Tmonth}-${Tday}`);
      await dispatch(slice.actions.startLoading());
      const response = await api.SaveACHRegistrationRequestWithAOSUseCase({
        AOSAI: JSON.stringify(objAuthInfoResponse),
        AMLA: Number(values.mandateAmount),
        AMVFD: utils.convertToSystemDateFormate(formattedFromDate),
        AMVTD: utils.convertToSystemDateFormate(formattedToDate),
      });

      if (!response.Status) {
        throw new Error(response.Message || "Unexpected Error");
      }

      if (!response.Message) throw new Error("No URL Found");
      const win = window.open(
        response.Message,
        "_blank",
        "width=1050,height=650,0,status=0,"
      );
      //@ts-ignore
      window.win = win;
      if (win) {
        try {
          win.focus();
        } catch (e) {
          throw new Error(
            "Pop-up Blocker is enabled! Please add this site to your exception list."
          );
        }
        utils.setOnWindowClose(win, () => {
          window.location.reload();
        });
      } else {
        throw new Error(
          "Pop-up Blocker is enabled! Please add this site to your exception list."
        );
      }
    } catch (ex) {
      console.log(ex, "ex");
      await dispatch(slice.actions.hasError(ex));
    }
  };
};
